var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("hom\n  "),_c('a',{attrs:{"href":"#/login"}},[_vm._v("tttttttttt")]),_vm._v("\n  e")])}]

export { render, staticRenderFns }